<template>
  <div class="results-page">
    <div class="mobile-tab-selector" @click="showMobileMenu = !showMobileMenu">
      <span>{{ getCurrentGameLabel }}</span>
      <i :class="['el-icon-arrow-down', {'el-icon-arrow-up': showMobileMenu}]"></i>
    </div>
    <div class="results-menu" :class="{'mobile-menu-active': showMobileMenu}">
      <router-link to="/results/lucky-ball-5" class="menu-item" :class="{ active: $route.path === '/results/lucky-ball-5' }" @click="closeMobileMenu">Lucky 5 Ball</router-link>
      <router-link to="/results/lucky-ball-8" class="menu-item" :class="{ active: $route.path === '/results/lucky-ball-8' }" @click="closeMobileMenu">Lucky 8 Ball</router-link>
      <router-link to="/results/lucky-ball-10" class="menu-item" :class="{ active: $route.path === '/results/lucky-ball-10' }" @click="closeMobileMenu">Lucky 10 Ball</router-link>
      <router-link to="/results/lucky-ball-20" class="menu-item" :class="{ active: $route.path === '/results/lucky-ball-20' }" @click="closeMobileMenu">Lucky 20 Ball</router-link>
    </div>
    <div class="results-content">
      <div class="latest-result">
        <div class="game-header">
          <img :src="require('@/assets/images/' + currentGameInfo.image)" class="game-logo" :alt="currentGameInfo.name">
          <div class="game-info">
            <div class="draw-time" v-if="latestResult">{{ formatDate(latestResult.Date) }}</div>
            <div class="draw-time" v-else>Loading...</div>
            <div class="draw-number" v-if="latestResult">Draw: {{ latestResult.GameID }}</div>
            <div class="draw-number" v-else>Please wait</div>
          </div>
        </div>
        <div class="result-numbers" v-if="latestResult">
          <div 
            class="ball" 
            v-for="(num, i) in formatDrawNumbers(latestResult.GameValue)" 
            :key="i"
            :style="getBallStyle()"
          >{{ num }}</div>
        </div>
        <div class="result-numbers loading" v-else>
          <div class="loading-message">Loading latest result...</div>
        </div>
        <div class="next-draw">
          <div class="next-draw-label" v-if="latestResult">Next Draw: {{ latestResult.nextIssue||'--'}}</div>
          <div class="next-draw-label" v-else>Next Draw: --</div>
          <div class="countdown">{{ countdown }}</div>
        </div>
      </div>

      <div class="past-results">
        <div class="section-header">
          <div class="title">Past Results</div>
          <div class="order-info">Number Order: Drawn</div>
          <div class="filter">
            <div class="date-picker">
              <input 
                type="date" 
                v-model="selectedDate" 
                class="date-input" 
                @change="applyDateFilter"
              />
              <button class="search-btn" @click="applyDateFilter">
                <i class="search-icon">🔍</i>
              </button>
            </div>
          </div>
        </div>
        <div class="result-list">
          <div class="result-item" v-for="(result, index) in filteredResults" :key="index">
            <div class="draw-info">
              <div class="draw-time">{{ formatDate(result.Date,'short') }}</div>
              <div class="draw-number">Draw: {{ result.GameID }}</div>
            </div>
            <div class="result-numbers small">
              <div 
                class="ball" 
                v-for="(num, i) in formatDrawNumbers(result.GameValue)" 
                :key="i"
                :style="getBallStyle()"
              >{{ num }}</div>
            </div>
          </div>
          <div v-if="isLoading" class="loading-container">
            <div class="loading-message">Loading results...</div>
          </div>
          <div v-else-if="filteredResults.length === 0" class="no-results">
            No results found for this time period
          </div>
        </div>
        <div class="load-more" v-if="filteredResults.length > 0 && hasMoreResults && !isLoading">
          <button class="more-btn" @click="loadMore">Load More Results</button>
        </div>
      </div>

      <div class="results-banner">
        <img :src="require('@/assets/images/results-banner_new.jpg')" alt="Results">
      </div>
    </div>
  </div>
</template>

<script>
var api = require('../services/api');
var Ball = require('@/components/shared/Ball');

export default {
  name: 'Results',
  components: {
    Ball
  },
  data() {
    return {
      showMobileMenu: false,
      pageSize: 10,
      currentPage: 1,
      hasMoreResults: true,
      isLoading: false,
      gameData: {
        'lucky-ball-5': { id: 1504, name: 'Lucky 5 Ball', image: 'ball5_new.png', color: '#e95455' },
        'lucky-ball-8': { id: 1506, name: 'Lucky 8 Ball', image: 'ball8.png', color: '#00a0e9' },
        'lucky-ball-10': { id: 1505, name: 'Lucky 10 Ball', image: 'ball10.png', color: '#ffa200' },
        'lucky-ball-20': { id: 1507, name: 'Lucky 20 Ball', image: 'ball20.png', color: '#8dc21f' }
      },
      currentGame: null,
      latestResult: null,
      countdown: '00:00',
      countdownInterval: null,
      historyResults: [],
      searchIssue: '',
      searchDate: '',
      selectedDate: ''
    };
  },
  computed: {
    currentGameId() {
      var gameSlug = this.$route.params.game;
      return this.gameData[gameSlug] ? this.gameData[gameSlug].id : 1504; // 默认为Lucky 5 Ball
    },
    currentGameInfo() {
      var gameSlug = this.$route.params.game;
      return this.gameData[gameSlug] || this.gameData['lucky-ball-5'];
    },
    filteredResults() {
      return this.historyResults;
    },
    getCurrentGameLabel() {
      var gameSlug = this.$route.params.game;
      switch(gameSlug) {
        case 'lucky-ball-5': return 'Lucky 5 Ball';
        case 'lucky-ball-8': return 'Lucky 8 Ball';
        case 'lucky-ball-10': return 'Lucky 10 Ball';
        case 'lucky-ball-20': return 'Lucky 20 Ball';
        default: return 'Lucky 5 Ball';
      }
    }
  },
  methods: {
    closeMobileMenu() {
      this.showMobileMenu = false;
    },
    fetchLatestResult() {
      var self = this;
      self.latestResult = null; // 清空旧数据
      
      api.getLastResult(this.currentGameId)
        .then(function(response) {
          console.log('Latest Result Data:', response.data);
          if (response.data && response.data.lastResult) {
            self.latestResult = response.data.lastResult;
            self.latestResult.nextIssue=response.data.nextIssue;
            // 开始倒计时
            if (response.data.secondsLeft) {
              self.startCountdown(response.data.secondsLeft);
            }
          }
        })
        .catch(function(error) {
          console.error('Error fetching latest result:', error);
        });
    },
    fetchHistoryResults() {
      var self = this;
      self.isLoading = true;
      
      // 使用选择的日期
      var searchDate = this.selectedDate;
      self.historyResults = []; // 清空旧数据
      console.log('Fetching history with params:', {
        gameId: this.currentGameId,
        pageNum: this.currentPage,
        searchIssue: this.searchIssue,
        searchDate: searchDate,
        limit: this.pageSize
      });
      
      api.getHistoryResults(this.currentGameId, this.currentPage, this.searchIssue, searchDate, this.pageSize)
        .then(function(response) {
          console.log('History Results Data:', response.data);
          if (response.data) {
            // 访问正确的数据结构 - API返回的数据中results字段包含实际结果
            var responseData = response.data.results || response.data;
            
            // 如果是第一页，替换现有结果；否则，添加到现有结果
            if (self.currentPage === 1) {
              self.historyResults = responseData;
            } else {
              self.historyResults = self.historyResults.concat(responseData);
            }
            
            // 判断是否还有更多结果
            self.hasMoreResults = responseData && responseData.length === self.pageSize;
            
            // 打印处理后的数据
            console.log('处理后的历史数据:', self.historyResults);
          } else {
            // 如果没有返回数据或返回空数组
            if (self.currentPage === 1) {
              self.historyResults = [];
            }
            self.hasMoreResults = false;
          }
        })
        .catch(function(error) {
          console.error('Error fetching history results:', error);
          // 出错时，清空结果或保持原有结果
          if (self.currentPage === 1) {
            self.historyResults = [];
          }
          self.hasMoreResults = false;
        })
        .finally(function() {
          self.isLoading = false;
        });
    },
    loadMore() {
      if (!this.isLoading && this.hasMoreResults) {
        this.currentPage++;
        this.fetchHistoryResults();
      }
    },
    startCountdown(seconds) {
      var self = this;
      
      // 清除现有的倒计时
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      
      // 设置初始倒计时值
      this.updateCountdown(seconds);
      
      // 开始倒计时
      this.countdownInterval = setInterval(function() {
        seconds--;
        
        if (seconds <= 0) {
          // 时间到，重新获取最新结果
          clearInterval(self.countdownInterval);
          self.fetchLatestResult();
        } else {
          // 更新倒计时
          self.updateCountdown(seconds);
        }
      }, 1000);
    },
    updateCountdown(seconds) {
      var minutes = Math.floor(seconds / 60);
      var remainingSeconds = seconds % 60;
      
      var minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
      var secondsStr = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds.toString();
      
      this.countdown = minutesStr + ':' + secondsStr;
    },
    formatDate(dateStr,weekDayType) {
      if (!dateStr) return '';
      if(!weekDayType)
	  weekDayType='long';
      var date = new Date(dateStr);
      
      // 检查日期是否有效
      if (isNaN(date.getTime())) {
        return dateStr; // 如果无效，直接返回原字符串
      }
      
      // 格式化日期: Wednesday, Apr 23, 2025 05:19 am (ACST)
      var options = { 
        weekday: weekDayType, 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric',
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true
      };
      
      try {
        return date.toLocaleDateString('en-US', options) + ' (ACST)';
      } catch (error) {
        console.error('Date formatting error:', error);
        return dateStr;
      }
    },
    formatDrawNumbers(gameValue) {
      if (!gameValue) {
        console.warn('formatDrawNumbers: received empty gameValue');
        return [];
      }
      
      console.log('formatDrawNumbers processing:', gameValue);
      
      try {
        // 拆分逗号分隔的数字
        var numbers = gameValue.split(',').map(function(num) {
          return parseInt(num.trim(), 10);
        });
        console.log('Formatted numbers:', numbers);
        return numbers;
      } catch (error) {
        console.error('Error formatting draw numbers:', error, gameValue);
        return [];
      }
    },
    getBallStyle() {
      return {
        background: 'linear-gradient(to bottom, ' + this.currentGameInfo.color + ' 8%, ' + this.darkenColor(this.currentGameInfo.color) + ' 100%)'
      };
    },
    darkenColor(color) {
      try {
        var hex = color.replace('#', '');
        var r = parseInt(hex.substr(0, 2), 16);
        var g = parseInt(hex.substr(2, 2), 16);
        var b = parseInt(hex.substr(4, 2), 16);

        var darkenAmount = 0.2;
        var darkenR = Math.floor(r * (1 - darkenAmount));
        var darkenG = Math.floor(g * (1 - darkenAmount));
        var darkenB = Math.floor(b * (1 - darkenAmount));
        
        // 转为16进制并添加前导零
        var rHex = darkenR.toString(16);
        var gHex = darkenG.toString(16);
        var bHex = darkenB.toString(16);
        
        rHex = rHex.length === 1 ? '0' + rHex : rHex;
        gHex = gHex.length === 1 ? '0' + gHex : gHex;
        bHex = bHex.length === 1 ? '0' + bHex : bHex;

        return '#' + rHex + gHex + bHex;
      } catch (error) {
        console.error('Error darkening color:', error);
        return '#999999'; // 返回默认颜色
      }
    },
    applyDateFilter() {
      this.currentPage = 1;
      this.hasMoreResults = true;
      this.fetchHistoryResults();
    },
    getTodayDate() {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() + 1;
      var day = today.getDate();
      
      // 添加前导零
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      
      return year + '-' + month + '-' + day;
    }
  },
  watch: {
    '$route.params.game': function() {
      // 当路由参数变化时，重新获取数据
      this.currentPage = 1;
      this.hasMoreResults = true;
      this.fetchLatestResult();
      this.fetchHistoryResults();
    }
  },
  mounted() {
    // 设置今天的日期
    this.selectedDate = this.getTodayDate();
    
    // 获取最新结果和历史结果
    this.fetchLatestResult();
    this.fetchHistoryResults();
  },
  beforeDestroy() {
    // 清除倒计时
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}
</script>

<style scoped>
.results-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 30px;
  box-sizing: border-box;
}

.results-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-item {
  padding: 12px 15px;
  background-color: #f5f5f5;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  border-radius: 4px;
  transition: all 0.3s;
}

.menu-item:hover,
.menu-item.active {
  background-color: #e03997;
  color: white;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.results-content {
  background: white;
  border-radius: 4px;
  padding: 25px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.mobile-tab-selector {
  display: none;
  padding: 15px;
  background-color: #e03997;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 5px rgba(224, 57, 151, 0.3);
}

.latest-result {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 6px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.game-header {
  display: flex;
  align-items: center;
  gap: 20px;
}

.game-logo {
  width: 70px;
  height: 70px;
}

.game-info {
  text-align: left;
}

.draw-time {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.draw-number {
  font-size: 14px;
  color: #999;
}

.result-numbers {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin: 20px 0;
}

.result-numbers.small {
  justify-content: flex-end;
}

.ball {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: linear-gradient(to bottom, #e95455 8%, #e02120 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  box-shadow: 0 3px 5px rgba(0,0,0,0.1);
}

.result-numbers.small .ball {
  width: 35px;
  height: 35px;
  font-size: 18px;
}

.next-draw {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 15px;
}

.next-draw-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.countdown {
  font-size: 24px;
  color: #333;
  font-weight: bold;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 3px solid #f8e483;
  padding-bottom: 10px;
  margin: 30px 0 20px;
}

.title {
  font-size: 22px;
  color: #333;
  font-weight: bold;
}

.order-info {
  font-size: 14px;
  color: #666;
  font-weight: bold;
}

.filter {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.filter span {
  font-size: 14px;
  color: #666;
}

.date-picker {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-input {
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
}

.search-btn {
  padding: 6px 12px;
  background-color: #e03997;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.search-icon {
  font-size: 18px;
  color: white;
}

.result-list {
  display: flex;
  flex-direction: column;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}

.draw-info {
  text-align: left;
}

.no-results {
  text-align: center;
  padding: 30px;
  color: #999;
  font-style: italic;
}

.load-more {
  text-align: center;
  margin-top: 30px;
}

.more-btn {
  padding: 10px 30px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
}

.more-btn:hover {
  background-color: #e03997;
  color: white;
  border-color: #e03997;
}

.results-banner {
  text-align: center;
  margin-top: 30px;
}

.results-banner img {
  max-width: 100%;
  height: auto;
}

.loading-container {
  text-align: center;
  padding: 30px;
  color: #999;
  font-style: italic;
}

.loading-message {
  font-size: 14px;
  color: #999;
}

@media (max-width: 768px) {
  .results-page {
    grid-template-columns: 1fr;
    padding: 15px;
    gap: 15px;
  }
  
  .mobile-tab-selector {
    display: flex;
  }
  
  .results-menu {
    display: none;
    position: absolute;
    z-index: 10;
    background: white;
    width: calc(100% - 30px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    border-radius: 4px;
    margin-top: -10px;
  }
  
  .results-menu.mobile-menu-active {
    display: flex;
  }
  
  .results-content {
    padding: 20px 15px;
  }
  
  .game-header {
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
  }
  
  .game-info {
    text-align: center;
    width: 100%;
    margin-top: 10px;
  }
  
  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .filter {
    width: 100%;
    align-items: flex-start;
    margin-top: 15px;
  }
  
  .date-picker {
    width: 100%;
  }
  
  .date-input {
    flex: 1;
  }
  
  .order-info {
    margin: 10px 0;
  }
}

@media (max-width: 576px) {
  .results-page {
    padding: 10px;
  }
  
  .results-content {
    padding: 15px 10px;
  }
  
  .latest-result {
    padding: 15px;
  }
  
  .game-logo {
    width: 60px;
    height: 60px;
  }
  
  .result-numbers {
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .ball {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
  
  .result-numbers.small .ball {
    width: 30px;
    height: 30px;
    font-size: 16px;
  }
  
  .result-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .result-numbers.small {
    justify-content: flex-start;
    margin-top: 10px;
  }
  
  .countdown {
    font-size: 20px;
  }
  
  .next-draw {
    align-items: flex-start;
  }
  
  .title {
    font-size: 20px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Results.vue